import { render, staticRenderFns } from "./DashboardNumberCard.vue?vue&type=template&id=23eaed66"
import script from "./DashboardNumberCard.vue?vue&type=script&lang=js"
export * from "./DashboardNumberCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports